module.exports = __webpack_public_path__ + "static/media/proj3_img3.26f0b715.jpg";